export default {
      id: "oc-safety-certificate-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#oc-safety-certificate",
      toString: function () {
        return this.url;
      }
    }